export const webLoginStorageKey = "webLoginKeyAndToken";
export const clubAppStorageKey = "clubAppKeyAndToken";
